import { purchaseBillAddApi } from "../../api/purchaseBill/purchaseBillAddApi"

type PayloadShape = Parameters<typeof purchaseBillAddApi>[0]

export async function purchaseBillAddService(payload: PayloadShape, token: string) {
	return await purchaseBillAddApi(payload, token)
}
